module.exports = __webpack_public_path__ + "media/images/price_list/feature-1-8b15d776ea4230ad96a5a50b35200ba6.webp";